export const BACKEND = "/api";